import { getDefaultExportFromCjs as l } from "./ghl-ui.es436.js";
import { __module as t } from "./ghl-ui.es1540.js";
import { i as n } from "./ghl-ui.es1541.js";
import { a as i } from "./ghl-ui.es1542.js";
(function(o, e) {
  var r = n.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = u;
  var a = r(i);
  function u(f) {
    return (0, a.default)({}, f);
  }
  o.exports = e.default;
})(t, t.exports);
var p = t.exports;
const x = /* @__PURE__ */ l(p);
export {
  x as default
};
